import Head from "next/head";

import config from "config";

import PrivateFlowGate from "modules/projects/elements/Private-Flow-Wrapper";
import NewProjectLayout from "modules/projects/elements/New-Project-Entitlement-Wrapper";

import * as flowConfig from "flows/eta-estimator/config";
import CreateNewProject from "flows/eta-estimator/views/create-project";

const CreateProject = () => {
  return (
    <>
      <Head>{config.SITE_NAME} | Create New ETA Estimator Project</Head>
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="pb-4 mb-8">
          <h1 className="h2 text-center">Start ETA Estimator Project</h1>
        </div>
        <CreateNewProject />
      </div>
    </>
  );
};

CreateProject.getLayout = (page) => (
  <PrivateFlowGate flowName={flowConfig.FLOW_NAME}>
    <NewProjectLayout>{page}</NewProjectLayout>
  </PrivateFlowGate>
);
export default CreateProject;
